import * as React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Erp from "./components/Erp";
import Sap from "./components/Sap";
import Career from "./components/Career";
import Careerform from "./components/Careerform";
import Itsupport from "./components/Itsupport";
import Payment from "./components/Payment";
import Barcode from "./components/Barcode";
import Tally from "./components/Tally";
import Visitorform from "./components/Visitorform";
import Scrolltotop from "./components/Scrolltotop";
import { Enquiry } from "./components/Enquiry";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Scrolltotop>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/services" element={<Services />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/footer" element={<Footer />}></Route>
          <Route path="/Erp" element={<Erp />}></Route>
          <Route path="/Sap" element={<Sap />}></Route>
          <Route path="/Career" element={<Career />}></Route>
          <Route path="/Careerform" element={<Careerform />}></Route>
          <Route path="/Itsupport" element={<Itsupport />}></Route>
          <Route path="/Payment" element={<Payment />}></Route>
          <Route path="/Barcode" element={<Barcode />}></Route>
          <Route path="/Tally" element={<Tally />}></Route>
          <Route path="/Visitorform" element={<Visitorform />}></Route>
          <Route path="/Enquiry" element={<Enquiry/>}></Route>
        </Routes>
      </Scrolltotop>
      <Footer />

      {/* <section className="counter-wrapper section-sm">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="title">
                <h2>Award-Winning Agency</h2>
                <p>
                  Vestibulum nisl tortor, consectetur quis imperdiet bibendum,
                  laoreet sed arcu. Sed condimentum iaculis ex, in faucibus
                  lorem accumsan non. Donec mattis tincidunt metus. Morbi sed
                  tortor a risus luctus dignissim.
                </p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-6 text-center ">
              <div className="counters-item">
                <i className="tf-ion-ios-alarm-outline"></i>
                <div>
                  <span className="counter" data-count="150">
                    0
                  </span>
                </div>
                <h3>Happy Clients</h3>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 col-xs-6 text-center ">
              <div className="counters-item">
                <i className="tf-ion-ios-analytics-outline"></i>
                <div>
                  <span className="counter" data-count="130">
                    0
                  </span>
                </div>
                <h3>Projects completed</h3>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 col-xs-6 text-center ">
              <div className="counters-item">
                <i className="tf-ion-ios-compose-outline"></i>
                <div>
                  <span className="counter" data-count="99">
                    0
                  </span>
                </div>
                <h3>Positive feedback</h3>
              </div>
            </div>

            <div className="col-md-3 col-sm-6 col-xs-6 text-center ">
              <div className="counters-item kill-border">
                <i className="tf-ion-ios-bolt-outline"></i>
                <div>
                  <span className="counter" data-count="250">
                    0
                  </span>
                </div>
                <h3>Cups of Coffee</h3>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="portfolio section-sm" id="portfolio">
        <div className="container-fluid">
          <div className="row ">
            <div className="col-lg-12">
              <div className="title text-center">
                <h2>Our Works</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Porro, veritatis. Lorem ipsum dolor sit amet, consectetur
                  adipisicing elit. Minima, vitae?{" "}
                </p>
                <div className="border"></div>
              </div>

              {/* <div className="portfolio-filter">
                <button type="button" data-filter="all">
                  All
                </button>
                <button type="button" data-filter="photography">
                  Photography
                </button>
                <button type="button" data-filter="ios">
                  IOS App
                </button>
                <button type="button" data-filter="development">
                  Development
                </button>
                <button type="button" data-filter="design">
                  Design
                </button>
              </div> */}

      {/* <div className="row filtr-container">
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, design"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-1.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-1.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, design, ios"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-2.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-2.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, photography, development"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-3.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-3.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, photography, ios"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-4.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-4.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, design"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-5.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-5.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, design, development"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-6.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-6.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, photography"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-7.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-7.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
                <div
                  className="col-md-3 col-sm-6 col-xs-6 filtr-item "
                  data-category="mix, design, development"
                >
                  <div className="portfolio-block">
                    <img
                      className="img-fluid"
                      src="images/portfolio/portfolio-1.jpg"
                      alt=""
                    />
                    <div className="caption">
                      <a
                        className="search-icon"
                        href="images/portfolio/portfolio-1.jpg"
                        data-lightbox="image-1"
                      >
                        <i className="tf-ion-ios-search-strong"></i>
                      </a>
                      <h4>
                        <a href="/">AirBnB Postcard</a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
      {/* </div> */}
      {/* </div> */}
      {/* </section>

      <section className="team-skills section-sm" id="skills">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title text-center">
                <h2>Our Skills</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Doloribus fugiat, vel veniam, eos et delectus eveniet
                  molestiae. Esse, voluptas ratione.
                </p>
                <div className="border"></div>
              </div>
            </div>

            {/* <div className="col-md-5">
              <div className="team-skills-content">
                <h2>Simple To Start</h2>
                <p>
                  Vestibulum nisl tortor, consectetur quis imperdiet bium,
                  letcu. Sedndime ntumiaculis ex, in faucibus lorem accumsan
                  non. Donec mattis tin unt metuorbi sed tort Igor aman luctus
                  dignissim. Vestibulum nisl tortor, consectetur quis imperdiet
                  bium, letcu. Sedndime ntumiaculis ex, in faucibus lorem
                  accumsan non.
                </p>
                <a href="/" className="btn btn-main mt-20">
                  Contact Us
                </a>
              </div>
            </div>
            <div className="col-md-6 col-md-offset-1">
              <div className="progress-block">
                <ul>
                  <li>
                    <span>Photoshop</span>
                    <div className="progress">
                      <div className="progress-bar"></div>
                    </div>
                  </li>
                  <li>
                    <span>Web Application</span>
                    <div className="progress">
                      <div className="progress-bar"></div>
                    </div>
                  </li>
                  <li>
                    <span>Andriod Application</span>
                    <div className="progress">
                      <div className="progress-bar"></div>
                    </div>
                  </li>
                  <li>
                    <span>IOS Development</span>
                    <div className="progress">
                      <div className="progress-bar"></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div> */}
      {/* </div> */}
      {/* <div className="row">
            <div className="col-md-12">
              <div id="clients-slider" className="clients-logo-slider">
                <img src="images/client-logo/logo1.png" alt="" />
                <img src="images/client-logo/logo-2.png" alt="" />
                <img src="images/client-logo/logo-3.png" alt="" />
                <img src="images/client-logo/logo-4.png" alt="" />
                <img src="images/client-logo/logo-5.png" alt="" />
                <img src="images/client-logo/logo1.png" alt="" />
                <img src="images/client-logo/logo-2.png" alt="" />
                <img src="images/client-logo/logo-3.png" alt="" />
                <img src="images/client-logo/logo-4.png" alt="" />
                <img src="images/client-logo/logo-5.png" alt="" />
              </div>
            </div>
          </div> */}
      {/* </div> */}
      {/* </section> */}
      {/* <section className="team" id="team"> */}
      {/* <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title text-center ">
                <h2>Our Team</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Doloremque quasi tempora obcaecati, quis similique quos.
                </p>
                <div className="border"></div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 ">
              <div className="team-member text-center">
                <div className="member-photo">
                  <img
                    className="img-fluid"
                    src="images/team/member-1.jpg"
                    alt="Meghna"
                  />

                  <div className="mask">
                    <ul className="clearfix">
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-google-outline"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-dribbble"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="member-content">
                  <h3>Michael Jonson</h3>
                  <span>Head Of Marketing</span>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aspernatur necessitatibus ullam, culpa odio.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 ">
              <div className="team-member text-center">
                <div className="member-photo">
                  <img
                    className="img-fluid"
                    src="images/team/member-2.jpg"
                    alt="Meghna"
                  />

                  <div className="mask">
                    <ul className="clearfix">
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-google-outline"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-dribbble"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="member-content">
                  <h3>Carrick Mollenkamp</h3>
                  <span>Web Developer</span>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aspernatur necessitatibus ullam, culpa odio.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 ">
              <div className="team-member text-center">
                <div className="member-photo">
                  <img
                    className="img-fluid"
                    src="images/team/member-3.jpg"
                    alt="Meghna"
                  />

                  <div className="mask">
                    <ul className="clearfix">
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-facebook"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-google-outline"></i>
                        </a>
                      </li>
                      <li>
                        <a href="/">
                          <i className="tf-ion-social-dribbble"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="member-content">
                  <h3>David Gauthier</h3>
                  <span>Head Of Management</span>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aspernatur necessitatibus ullam, culpa odio.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* </section> */}
      {/* <section className="pricing-table " id="pricing">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title title-white text-center ">
                <h2>Our Greatest Plans</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Laudantium soluta deserunt eaque, est, quia hic odit sed
                  incidunt officiis quidem.
                </p>
                <div className="border"></div>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12">
              <div className="pricing-item">
                <div className="price-title">
                  <h3>Basic</h3>
                  <strong className="value">$19</strong>
                  <p>Perfect for single freelancers who work by themselves</p>
                </div>

                <ul>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 1GB Disk Space
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 10 Email
                    Account
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Script
                    Installer
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 1 GB Storage
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 2 GB Bandwidth
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 24/7 Tech
                    Support
                  </li>
                </ul>

                <a className="btn btn-main" href="/">
                  Signup
                </a>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12  ">
              <div className="pricing-item">
                <div className="price-title">
                  <h3>Standard</h3>
                  <strong className="value">$39</strong>
                  <p>Suitable for small businesses with up to 5 employees</p>
                </div>

                <ul>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 1GB Disk Space
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 50 Email
                    Account
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Script
                    Installer
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 1 GB Storage
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 10 GB Bandwidth
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 24/7 Tech
                    Support
                  </li>
                </ul>

                <a className="btn btn-main" href="/">
                  Signup
                </a>
              </div>
            </div>

            <div className="col-md-4 col-sm-6 col-xs-12 ">
              <div className="pricing-item">
                <div className="price-title">
                  <h3>Enterprise</h3>
                  <strong className="value">$59</strong>
                  <p>Great for large businesses with more than 5 employees</p>
                </div>

                <ul>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Unlimited Disk
                    Space
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Unlimited Email
                    Account
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Script
                    Installer
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Unlimited
                    Storage
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> Unlimited
                    Bandwidth
                  </li>
                  <li>
                    <i className="tf-ion-ios-arrow-forward"></i> 24/7 Tech
                    Support
                  </li>
                </ul>

                <a className="btn btn-main" href="/">
                  Signup
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="testimonial section" id="testimonial">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="testimonial-slider">
                <div className="item text-center">
                  <i className="tf-ion-chatbubbles"></i>
                  <div className="client-details">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Eum nulla, soluta dolorum. Eos earum, magni asperiores,
                      unde corporis labore, enim, voluptatum officiis voluptates
                      alias natus. Lorem ipsum dolor sit amet, consectetur
                      adipisicing elit. Quia, officia. Lorem ipsum dolor sit
                      amet, consectetur adipisicing elit. Quod, quia?
                    </p>
                  </div>
                  <div className="client-thumb">
                    <img
                      src="images/client-logo/clients-1.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="client-meta">
                    <h3>William Martin</h3>
                    <span>CEO , Company Name</span>
                  </div>
                </div>
                <div className="item text-center">
                  <i className="tf-ion-chatbubbles"></i>

                  <div className="client-details">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Eum nulla, soluta dolorum. Eos earum, magni asperiores,
                      unde corporis labore, enim, voluptatum officiis voluptates
                      alias natus. Lorem ipsum dolor sit amet, consectetur
                      adipisicing elit. Quia, officia. Lorem ipsum dolor sit
                      amet, consectetur adipisicing elit. Quod, quia?
                    </p>
                  </div>
                  <div className="client-thumb">
                    <img
                      src="images/client-logo/clients-2.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="client-meta">
                    <h3>Emma Harrison</h3>
                    <span>CEO , Company Name</span>
                  </div>
                </div>
                <div className="item text-center">
                  <i className="tf-ion-chatbubbles"></i>

                  <div className="client-details">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Eum nulla, soluta dolorum. Eos earum, magni asperiores,
                      unde corporis labore, enim, voluptatum officiis voluptates
                      alias natus. Lorem ipsum dolor sit amet, consectetur
                      adipisicing elit. Quia, officia. Lorem ipsum dolor sit
                      amet, consectetur adipisicing elit. Quod, quia?
                    </p>
                  </div>
                  <div className="client-thumb">
                    <img
                      src="images/client-logo/clients-3.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div className="client-meta">
                    <h3>Alexander Lucas</h3>
                    <span>CEO , Company Name</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="blog" id="blog">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title text-center ">
                <h2>
                  {" "}
                  Latest <span className="color">Posts</span>
                </h2>
                <div className="border"></div>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Ducimus facere accusamus, reprehenderit libero inventore nam.
                </p>
              </div>
            </div>
            <article className="col-md-4 col-sm-6 col-xs-12 clearfix ">
              <div className="post-item">
                <div className="media-wrapper">
                  <img
                    src="images/blog/post-1.jpg"
                    alt="amazing caves coverimage"
                    className="img-fluid"
                  />
                </div>

                <div className="content">
                  <h3>
                    <a href="single-post.html">Reasons to Smile</a>
                  </h3>
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non skateboard dolor brunch.
                  </p>
                  <a className="btn btn-main" href="single-post.html">
                    Read more
                  </a>
                </div>
              </div>
            </article>
            <article className="col-md-4 col-sm-6 col-xs-12 ">
              <div className="post-item">
                <div className="media-wrapper">
                  <img
                    src="images/blog/post-2.jpg"
                    alt="amazing caves coverimage"
                    className="img-fluid"
                  />
                </div>

                <div className="content">
                  <h3>
                    <a href="single-post.html">A Few Moments</a>
                  </h3>
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non skateboard dolor brunch.
                  </p>
                  <a className="btn btn-main" href="single-post.html">
                    Read more
                  </a>
                </div>
              </div>
            </article>
            <article className="col-md-4 col-sm-6 col-xs-12 ">
              <div className="post-item">
                <div className="media-wrapper">
                  <img
                    src="images/blog/post-3.jpg"
                    alt="amazing caves coverimage"
                    className="img-fluid"
                  />
                </div>

                <div className="content">
                  <h3>
                    <a href="single-post.html">Hints for Life</a>
                  </h3>
                  <p>
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non skateboard dolor brunch.
                  </p>
                  <a className="btn btn-main" href="single-post.html">
                    Read more
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section> */}
      {/* <section className="contact-us" id="contact">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="title text-center">
                <h2>Get In Touch</h2>
                <p></p>
                <div className="border"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map">
        <div id="map_canvas"></div>
      </section> */}
    </div>
  );
}

export default App;
